var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('PsTabHeader',{attrs:{"items":_vm.getBuildingTypesItems,"selected":_vm.getBuildingTypeSelected,"key-label":'title',"key-value":'slug'},on:{"change":_vm.selectItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }